export default {
  methods: {
    customFilter (item, queryText, itemText) {
      let stringTags = item.tags ? item.tags.toString() : ''

      return itemText.indexOf(queryText) > -1 || stringTags.indexOf(queryText) > -1
    },
    preventNonNumericalInput (e) {
      e = e || window.event
      let charCode = (typeof e.which === 'undefined') ? e.keyCode : e.which
      let charStr = String.fromCharCode(charCode)

      if (!charStr.match(/^[0-9]+$/)) {
        e.preventDefault()
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mixins/utils.js